// extracted by mini-css-extract-plugin
export var animating = "_2h-3";
export var background = "_2h-6";
export var constrainHeight = "_2h-2";
export var dark = "_2h-4";
export var dropdown = "_2h-1";
export var leave = "_2h-5";
export var option = "_2h-7";
export var root = "_2h-0";